import { createDCHook, collapseDataFromCall } from '../client';
import { getAddressPrivate } from '../services/AddressService';

export const useAddressGetAddressPrivate = createDCHook('getAddressPrivate', collapseDataFromCall(getAddressPrivate), {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: true,
});
